import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserProfileConflictDeclarations.scss'
import * as commonStyles from '../../../common/_common.scss'
import { modificationStates } from '../../../common/ReducerHelperFunctions/listDifferenceComputer'
import React from 'react';

const createModificationClass = (modificationState) => {
  switch (modificationState) {
    case modificationStates.added:
      return commonStyles['item-added']
    case modificationStates.deleted:
      return commonStyles['item-deleted']
    case modificationStates.modified:
      return commonStyles['field-was-modified']
  }

  return ''
}

const AdviserProfileConflictDeclarations = ({
  conflictDeclarations = [],
  children,
  comparison
}) => (
  <div>
    <h4 className={styles['title']}>Conflict Declarations {children}</h4>
    <ul className={styles['list']}>

      {conflictDeclarations.length <= 0 && <li>No conflicts of interest</li>}
      {conflictDeclarations.map(function (declaration, i) {
        return (<li key={i} className={comparison ? createModificationClass(declaration.modificationState) : ''}> {declaration.description} </li>)
      })}
    </ul>
  </div>
)

AdviserProfileConflictDeclarations.propTypes = {
  conflictDeclarations: PropTypes.array.isRequired,
  children: PropTypes.object,
  comparison: PropTypes.bool
}

export default (AdviserProfileConflictDeclarations)
